import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function GoldenRingTerms() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white" data-testid="golden-ring-terms-page">
      <div className="max-w-2xl mx-auto px-5 py-8">
        <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-gray-500 mb-6 hover:text-gray-900">
          <ArrowLeft className="w-5 h-5" /> Indietro
        </button>

        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: "linear-gradient(135deg, #D4A574, #B8860B)" }}>
            <span className="text-white text-xl">💍</span>
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Golden Ring — Termini</h1>
            <p className="text-sm text-gray-400">Ultimo aggiornamento: Agosto 2026</p>
          </div>
        </div>

        <div className="prose prose-sm text-gray-700 space-y-6">
          <section>
            <h2 className="text-lg font-semibold text-gray-900">1. Cos'e il Golden Ring</h2>
            <p>Il <strong>Golden Ring</strong> e un sistema di riconoscimento virtuale all'interno dell'ecosistema ADE, gestito da <strong>A.d.E - Around. Discover. Engage</strong>. Rappresenta lo status raggiunto dall'utente in base alle interazioni ricevute sulla piattaforma.</p>
            <p>Il Golden Ring <strong>NON</strong> costituisce:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Un titolo, certificazione o qualifica professionale</li>
              <li>Un prodotto finanziario, investimento o asset digitale</li>
              <li>Un diritto a compensi, pagamenti o rendimenti</li>
              <li>Moneta elettronica, criptovaluta, valuta bancaria o strumento finanziario</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900">2. Come si Ottiene</h2>
            <p>Il livello Golden Ring aumenta automaticamente in base alle <strong>Gift ricevute</strong> da altri utenti. Non e possibile acquistare direttamente un livello Golden Ring.</p>
            <table className="w-full text-sm border-collapse mt-2">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left py-2">Livello</th>
                  <th className="text-left py-2">Nome</th>
                  <th className="text-left py-2">Requisito</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-100"><td className="py-2">0</td><td>Nessun Ring</td><td>—</td></tr>
                <tr className="border-b border-gray-100"><td className="py-2">1</td><td>Bronze Ring</td><td>1+ Gift ricevute</td></tr>
                <tr className="border-b border-gray-100"><td className="py-2">2</td><td>Silver Ring</td><td>5+ Gift ricevute</td></tr>
                <tr className="border-b border-gray-100"><td className="py-2">3</td><td>Gold Ring</td><td>10+ Gift ricevute</td></tr>
                <tr className="border-b border-gray-100"><td className="py-2">4</td><td>Platinum Ring</td><td>25+ Gift ricevute</td></tr>
                <tr><td className="py-2">5</td><td>Diamond Ring</td><td>50+ Gift ricevute</td></tr>
              </tbody>
            </table>
            <p className="text-xs text-gray-400 mt-2">I requisiti sono indicativi e possono essere modificati da A.d.E.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900">3. Caratteristiche del Golden Ring</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Indicatore visivo sul profilo (bordo dorato)</li>
              <li>Maggiore visibilita nel sistema di discovery</li>
              <li>Il livello e puramente estetico e di riconoscimento</li>
              <li>Non conferisce diritti economici ne privilegi contrattuali</li>
              <li>Non e trasferibile tra account</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900">4. Perdita del Golden Ring</h2>
            <p>A.d.E si riserva il diritto di rimuovere o ridurre il livello Golden Ring in caso di:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Violazione dei Termini di Servizio</li>
              <li>Gift ottenute tramite frode, self-gifting o account collegati</li>
              <li>Comportamento abusivo o ingannevole</li>
              <li>Chargeback sui pagamenti collegati alle Gift ricevute</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900">5. Relazione con ADE Coins e Gift</h2>
            <p>Le Gift che contribuiscono al Golden Ring sono acquistate da altri utenti utilizzando crediti interni ADE (ADE Coins). Il Golden Ring riflette l'apprezzamento ricevuto dalla community, <strong>non</strong> il valore monetario delle Gift ricevute.</p>
            <p className="mt-2">Gli ADE Coins sono crediti interni della piattaforma e non costituiscono criptovaluta, valuta bancaria o strumento finanziario di alcun tipo.</p>
            <p className="mt-2">Il sistema Golden Ring e indipendente dal sistema Creator Rewards e Cash-out. Il possesso di un alto livello Golden Ring non conferisce automaticamente il diritto al Cash-out.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900">6. Abbonamento Golden Ring (v. GR-SUB-1.0)</h2>
            <p>Il Golden Ring è uno status di verifica ADE. L'approvazione si basa esclusivamente sulla documentazione esaminata da ADE: la fascia richiesta non è garantita e la fascia approvata può differire da quella richiesta.</p>
            <p className="mt-2">Il badge Golden Ring visibile richiede, oltre alla verifica approvata, un <strong>abbonamento mensile attivo</strong> corrispondente alla fascia approvata: Bronze €9,99/mese, Silver €19,99/mese, Gold €49,99/mese, Gold Plus €99,99/mese. <strong>Primo mese gratuito</strong> (una sola volta per utente, secondo l'idoneità del fornitore di pagamento), poi rinnovo automatico mensile fino alla disattivazione.</p>
            <p className="mt-2">La disattivazione del rinnovo ha effetto al termine del periodo di fatturazione in corso: il Golden Ring resta attivo fino a tale data e la verifica approvata resta registrata, consentendo la riattivazione senza ripetere la verifica salvo revoca, rinnovo documentale o esigenze di conformità. Su iOS e Android la gestione dell'abbonamento avviene tramite le impostazioni abbonamenti di App Store / Google Play, con le relative regole di rimborso del fornitore.</p>
            <p className="mt-2">Il pagamento <strong>non garantisce</strong> l'esito della verifica e l'abbonamento <strong>non consente</strong> di acquistare una fascia di verifica superiore. A.d.E può sospendere o revocare la verifica in caso di documentazione falsa, alterata o fuorviante. Il trattamento dei documenti avviene secondo la Privacy Policy.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900">7. Modifiche</h2>
            <p>A.d.E si riserva il diritto di modificare i livelli, i requisiti e le caratteristiche del Golden Ring. Eventuali modifiche significative saranno comunicate tramite l'app.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900">8. Titolare</h2>
            <p><strong>A.d.E - Around. Discover. Engage</strong></p>
            <p>Via Marie Curie 17, 39100 Bolzano (BZ) — Italia</p>
            <p>P.IVA / C.F.: 03062850999</p>
            <p>PEC: <a href="mailto:arabellgroupsrls@legalmail.it" className="text-blue-600">arabellgroupsrls@legalmail.it</a></p>
          </section>

          <p className="text-xs text-gray-400 mt-8 pt-4 border-t">
            Versione documento: 1.1 (Termini abbonamento: GR-SUB-1.0) — A.d.E - Around. Discover. Engage
          </p>
        </div>
      </div>
    </div>
  );
}
